import { RightOutlined } from "@ant-design/icons";
import React, { FC } from "react";
import { JButton } from "../JButton";
import "./ActionBanner.css";

export type ActionBannerProps = {
    title: string;
    text?: string;
    src?: string;
    actionLabel?: string;
    actionCallback: () => void;
    small?: boolean
};

/**
 * Action banner component
 *
 * @param {ActionBannerProps} props
 * @return {*} 
 */
export const ActionBanner: FC<ActionBannerProps> = (
    {
        title,
        text,
        src,
        actionLabel,
        actionCallback,
        small
    }
) => {
    return (
        <div className={`action-banner-container ${small && "small"}`}
             style={src ? {backgroundImage: `url('${src}')`} : {}}
             onClick={()=>actionCallback && actionCallback()}
        >
            {title && <div className='action-banner-title'>{title}</div>}
            {text && <div className='action-banner-text'>{text}</div>}
            {(actionLabel || small) &&
                <JButton
                    className='action-banner-button'
                    shape={small ? "circle" : "round"}
                    jType={small ? "primary" : "secondary"}
                >
                    {small ? <RightOutlined aria-hidden={true} /> : actionLabel}
                </JButton>
            }
        </div>
    )
}
